import { j as h } from "./atoms-v218.js";
import { useMemo as I, useRef as g, useState as w, useContext as K } from "react";
import { LayoutGroupContext as M } from "./atoms-v2871.js";
import { useConstant as N } from "./atoms-v2872.js";
import { PresenceChild as T } from "./atoms-v2873.js";
import { usePresence as F } from "./atoms-v2874.js";
import { onlyElements as R, getChildKey as c } from "./atoms-v2875.js";
import { useIsomorphicLayoutEffect as G } from "./atoms-v2876.js";
const H = ({ children: p, custom: j, initial: k = !0, onExitComplete: C, presenceAffectsLayout: A = !0, mode: u = "sync", propagate: l = !1 }) => {
  const [x, d] = F(l), n = I(() => R(p), [p]), o = l && !x ? [] : n.map(c), y = g(!0), v = g(n), r = N(() => /* @__PURE__ */ new Map()), [L, b] = w(n), [i, E] = w(n);
  G(() => {
    y.current = !1, v.current = n;
    for (let t = 0; t < i.length; t++) {
      const e = c(i[t]);
      o.includes(e) ? r.delete(e) : r.get(e) !== !0 && r.set(e, !1);
    }
  }, [i, o.length, o.join("-")]);
  const f = [];
  if (n !== L) {
    let t = [...n];
    for (let e = 0; e < i.length; e++) {
      const s = i[e], a = c(s);
      o.includes(a) || (t.splice(e, 0, s), f.push(s));
    }
    u === "wait" && f.length && (t = f), E(R(t)), b(n);
    return;
  }
  process.env.NODE_ENV !== "production" && u === "wait" && i.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: m } = K(M);
  return h.jsx(h.Fragment, { children: i.map((t) => {
    const e = c(t), s = l && !x ? !1 : n === i || o.includes(e), a = () => {
      if (r.has(e))
        r.set(e, !0);
      else
        return;
      let P = !0;
      r.forEach((D) => {
        D || (P = !1);
      }), P && (m == null || m(), E(v.current), l && (d == null || d()), C && C());
    };
    return h.jsx(T, { isPresent: s, initial: !y.current || k ? void 0 : !1, custom: s ? void 0 : j, presenceAffectsLayout: A, mode: u, onExitComplete: s ? void 0 : a, children: t }, e);
  }) });
};
export {
  H as AnimatePresence
};
